import { Component, OnDestroy, OnInit } from '@angular/core';
import { JobsService } from '../../../pages/pages/jobs/jobs.service';
import { UserPromptService } from '../../../pages/pages/user-prompts/user-prompt.service';
import { ToasterService } from '../../services/toaster.service';
import { Router } from '@angular/router';

@Component({
  selector: 'gtapp-pre-safety-prompts',
  standalone: false,
  templateUrl: './pre-safety-prompts.component.html',
  styleUrl: './pre-safety-prompts.component.scss',
})
export class PreSafetyPromptsComponent implements OnInit, OnDestroy {
  availableJobTypes: any = [];
  preAssignedPrompts: any = {};
  userPromptDropDownList: any = [];
  constructor(
    private jobService: JobsService,
    private userPromptService: UserPromptService,
    private toasterService: ToasterService,
    private router: Router,
  ) {}

  ngOnDestroy(): void {}
  ngOnInit(): void {
    this.getAllPossibleJobTypes();
    this.getPreSafetyPromptList();
    this.searchUserPrompts('');
  }

  getAllPossibleJobTypes() {
    let subscriberStats = JSON.parse(
      localStorage.getItem('subscriberStats') || '{}',
    );

    this.jobService.getJobParams().subscribe((response: any) => {
      const filteredJobTypes = (response?.data || [])?.filter(
        (_type: any) =>
          ![0, 5].includes(_type?.type_identity) &&
          (_type?.type_identity === 4
            ? subscriberStats.checkpoint_count > 0
            : true),
      );
      this.availableJobTypes = filteredJobTypes;
    });
  }
  getPreSafetyPromptList() {
    let params: any = { rows: 10, pre_shift_safety_check: 1 };

    this.userPromptService
      .getUserPromptList(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          // this.preAssignedPrompts = new Map(
          //   (response?.data || [])?.map((item: any) => [item?.id, item]),
          // );
          this.preAssignedPrompts = (response?.data || [])?.reduce(
            (acc: any, item: any) => {
              if (item?.job_type) {
                acc[item.job_type] = item;
              }
              return acc;
            },
            {},
          );
        }
      });
  }
  onUserPromptLookup(event: any) {
    if (event.target.value.length > 2) {
      this.searchUserPrompts(event.target.value);
    }
  }
  searchUserPrompts(searchStr: '') {
    this.userPromptService
      .getUserPromptList({ search_str: searchStr })
      .subscribe((res: any) => {
        if (res['status'] == 'success') {
          this.userPromptDropDownList = res?.data;
        }
      });
  }
  redirectToMobileForms() {
    this.router.navigate(['/mobile-forms']);
  }
  updatePreSafetyPrompt(promptData: any, jobType: any, removePrompt = false) {
    if (promptData?.key == 0) {
      this.router.navigate(['/mobile-form']);
      return;
    }
    this.userPromptService
      .updateUserPrompt(promptData?.id, {
        update_pre_shift_safety_check: 1,
        job_type_id: jobType?.id,
        remove_prompt: removePrompt,
      })
      .subscribe((response: any) => {
        if (response?.status === 'success') {
          this.toasterService.setMessage({
            successMessage: response?.message,
            errorMessage: '',
          });
          if (removePrompt) {
            this.preAssignedPrompts[jobType?.id] = {};
          } else {
            this.preAssignedPrompts[jobType?.id] = promptData;
          }
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }
      });
  }
}
